import { PrioritySeverityLevel } from "../enums/PrioritySeverityLevel";
import { ImpactSeverityLevel } from "../enums/ImpactSeverityLevel";
import { ProbabilitySeverityLevel } from "../enums/ProbabilitySeverityLevel";

export const mapPriorityValueToSeverityLevel = (value: number): PrioritySeverityLevel | null=> {
    if (isNaN(value) || value <= 0) {
        return null;
    }
    if (value <= 2) {
        return PrioritySeverityLevel.Low;
    }
    if (value <= 5) {
        return PrioritySeverityLevel.Medium;
    }
    if (value <= 9) {
        return PrioritySeverityLevel.High;
    }
    return PrioritySeverityLevel.Critical;
};

type SeverityLevel = ImpactSeverityLevel | ProbabilitySeverityLevel | PrioritySeverityLevel;
export const getPrimaryColor = (severityLevel: SeverityLevel | null): string => {
    switch (severityLevel) {
        case ImpactSeverityLevel.Low:
        case ProbabilitySeverityLevel.Low:
        case PrioritySeverityLevel.Low:
            return "#3a9f0f";
        case ImpactSeverityLevel.Medium:
        case ProbabilitySeverityLevel.Medium:
        case PrioritySeverityLevel.Medium:
            return "#d48806";
        case ImpactSeverityLevel.High:
        case ProbabilitySeverityLevel.High:
        case PrioritySeverityLevel.High:
            return "#d46b08";
        case ImpactSeverityLevel.Urgent:
        case PrioritySeverityLevel.Critical:
            return "#cf1322";
        default:
            return "lightgray";
    }
};

export const getSecondaryColor = (severityLevel: SeverityLevel | null): string => {
    switch (severityLevel) {
        case ImpactSeverityLevel.Low:
        case ProbabilitySeverityLevel.Low:
        case PrioritySeverityLevel.Low:
            return "#ecf6e8";
        case ImpactSeverityLevel.Medium:
        case ProbabilitySeverityLevel.Medium:
        case PrioritySeverityLevel.Medium:
            return "#fbf4e8";
        case ImpactSeverityLevel.High:
        case ProbabilitySeverityLevel.High:
        case PrioritySeverityLevel.High:
            return "#fbf1e8";
        case ImpactSeverityLevel.Urgent:
        case PrioritySeverityLevel.Critical:
            return "#f2e2e5";
        default:
            return "lightgray";
    }
};

type MessageKey = 'low' | 'medium' | 'high' | 'urgent' | 'critical' | null;
export const getMessageKey = (severityLevel: SeverityLevel | null): MessageKey => {
    switch (severityLevel) {
        case ImpactSeverityLevel.Low:
        case ProbabilitySeverityLevel.Low:
        case PrioritySeverityLevel.Low:
            return 'low';
        case ImpactSeverityLevel.Medium:
        case ProbabilitySeverityLevel.Medium:
        case PrioritySeverityLevel.Medium:
            return 'medium';
        case ImpactSeverityLevel.High:
        case ProbabilitySeverityLevel.High:
        case PrioritySeverityLevel.High:
            return 'high';
        case ImpactSeverityLevel.Urgent:
            return 'urgent';
        case PrioritySeverityLevel.Critical:
            return 'critical';
        default:
            return null;
    }
};